import React, { useEffect } from 'react'
import { Grid } from '@mui/material';
const Swal = require('sweetalert2');

export const Expire = () => {
  useEffect(() => {
    const token = localStorage.getItem('token')
    fetch('http://27.254.66.164:5000/Author',{
    method: 'POST',
    mode: 'cors',
    headers: {
        'Authorization': 'Bearer '+token,
        'Content-Type': 'application/json',
    },
})
.then(response => response.json())
.then(data => {
        if (data.status === 'ok'){
        } else {
          
          Swal.fire({
            title: 'เซสชั่นหมดอายุ',
            text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง',
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: false,
            timer: 2000
          }).then((result) => {
              window.location.href = '/ec-crm/Login'
          })
        }
    });
  },[])
    return ( 
            <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '85vh' }}
            >

            <Grid item xs={3}>
                <img src = {require('./../img/CRMPic.png')} width = "100%" alt="logo"/>  
            </Grid>   
            
            </Grid>                     
    )
  
}



